import {applyMiddleware} from 'redux';

import { createRootReducer } from './rootReducer';
import { legacy_createStore as createStore} from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk } from 'redux-thunk';
import IStore from '../models/IStore';

export const configureStore =(initialState:IStore) => createStore(
  createRootReducer(),
  initialState,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
)
